import { BaseComponent } from '../../components/base-component'
import { $el } from 'src/scripts/utils/utils'

const FORM_SELECTOR = '[data-register-form]'

export class RegisterComponent extends BaseComponent {
  mountComponent(): void {
    const form = $el(FORM_SELECTOR, this)
    this.addListener(form, 'submit', this.handleSubmit)
  }

  handleSubmit(): void {
    localStorage.setItem('isRegistered', 'true')
  }
}
